import { gql } from "@apollo/client";
import { PublishedAppViewInAppReferrer } from "@hex/common";
import React, { useMemo } from "react";

import { IN_APP_REFERRER_PARAM } from "../app/AppSessionLoader.js";
import { SmallRowNavItem } from "../home/SmallRowNavItem.js";

import { SidebarSection } from "./favorite-projects-and-collection-rows/SidebarSection.js";
import { useGetStarredProjectsForSidebarQuery } from "./FavoriteProjects.generated.js";

const referrerParams = {
  [IN_APP_REFERRER_PARAM]: PublishedAppViewInAppReferrer.FAVORITES,
};

gql`
  query GetStarredProjectsForSidebar {
    hexes(ownershipLevel: ALL, onlyStarred: true, first: 30) {
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          ...HexListFragment
        }
      }
    }
  }
`;
type FavoriteProjectsProps = {
  hideIfEmpty?: boolean;
  location: "popover_sidebar" | "home_sidebar";
};
export const FavoriteProjects: React.ComponentType<FavoriteProjectsProps> =
  React.memo(function FavoriteProjects({
    hideIfEmpty,
    location,
  }: FavoriteProjectsProps) {
    const { data, error, loading } = useGetStarredProjectsForSidebarQuery({
      fetchPolicy: "network-only",
      nextFetchPolicy: "cache-first",
    });

    const starredHexes = useMemo(
      () =>
        data?.hexes.edges.map(({ node: hex }) => (
          <SmallRowNavItem
            key={hex.id}
            canEdit={hex.canEdit}
            canViewLogic={hex.canViewLogic}
            counterEventName={`${location}.favorites.project.click`}
            id={hex.id}
            isPublished={hex?.lastPublishedVersion != null}
            isStarred={true}
            referrerParams={referrerParams}
            title={hex.title}
            type={hex.hexType}
          />
        )) ?? [],
      [data?.hexes.edges, location],
    );

    return (
      <SidebarSection
        error={error}
        hideIfEmpty={hideIfEmpty}
        items={starredHexes}
        loading={loading}
        localStorageKey="SIDEBAR_FAVORITE_PROJECTS_OPENED"
        text="Favorite projects"
      />
    );
  });
